export default "__VITE_ASSET__CcHcgYnL__"